import { filter } from "rxjs/operators";
export function ofType() {
    var creators = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        creators[_i] = arguments[_i];
    }
    return filter(function (_a) {
        var type = _a.type;
        return creators.some(function (creator) { return creator.type === type; });
    });
}
